import { useCallback, useEffect, useRef } from "react";

export function useDebounce(func, delay) {
  const timeoutRef = useRef(null);
  const funcRef = useRef(func);

  // Always keep the latest func reference
  useEffect(() => {
    funcRef.current = func;
  }, [func]);

  const debouncedFn = useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      funcRef.current(...args);
    }, delay);
  }, [delay]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return debouncedFn;
}
